import * as PopoverPrimitive from '@radix-ui/react-popover';
import { forwardRef } from 'react';

import { cn } from './cn';
import { useReturnFocus } from './useReturnFocus';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(
  (
    {
      align = 'center',
      children,
      className,
      sideOffset = 6,
      onOpenAutoFocus,
      onCloseAutoFocus,
      onInteractOutside,
      ...props
    },
    ref,
  ) => {
    // Popovers are non-modal: a click elsewhere closes them and keeps its own focus.
    const { handlers, capture } = useReturnFocus({
      onOpenAutoFocus,
      onCloseAutoFocus,
      onInteractOutside,
      skipAfterOutside: true,
    });
    return (
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          ref={ref}
          {...handlers}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            'z-menu w-72 rounded-auditor-lg border border-line bg-surface p-4 text-ink shadow-auditor-overlay outline-hidden',
            'opacity-0 transition data-[state=open]:opacity-100 data-[state=open]:scale-100 data-[state=closed]:scale-95',
            className,
          )}
          {...props}
        >
          {capture}
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    );
  },
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
